/**
Tween three.js objects
Usage:
TweenMax.to(yourThreeJSObject, 1, {object3d: new THREE.Object3D()});
TweenMax.to(yourThreeJSObject, 1, {position3d: new THREE.Vector3()});
TweenMax.to(yourThreeJSObject, 1, {quaternion: new THREE.Quaternion()});
*/
var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
    "use strict";

    _gsScope._gsDefine.plugin({
        propName: "object3d",
        priority: 0,
        API: 2,
        version: "1.0.0",
        overwriteProps: ["object3d"],

        init: function(target, value, tween) {
            this._target = target;

            this._quaternionStart = target.quaternion.clone();
            this._quaternionEnd = value.quaternion.clone();

            this._positionStart = target.position.clone();
            this._positionEnd = value.position.clone();

            return true;
        },

        set: function(ratio) {
            this._super.setRatio.call(this, ratio);

            var quat = new THREE.Quaternion();
            THREE.Quaternion.slerp(this._quaternionStart, this._quaternionEnd, quat, ratio);
            this._target.quaternion.copy(quat);

            var p = this._positionStart.clone();
            p.lerp(this._positionEnd, ratio);
            this._target.position.copy(p);
        }

    });

    _gsScope._gsDefine.plugin({
        propName: "position3d",
        priority: 0,
        API: 2,
        version: "1.0.0",
        overwriteProps: ["position3d"],

        init: function(target, value, tween) {
            this._target = target;
            if (target.position) this._target = target.position;

            this._positionStart = this._target.clone();
            this._positionEnd = value.clone();

            return true;
        },

        set: function(ratio) {
            this._super.setRatio.call(this, ratio);

            var p = this._positionStart.clone();
            p.lerp(this._positionEnd, ratio);
            this._target.copy(p);
        }

    });

    _gsScope._gsDefine.plugin({
        propName: "quaternion",
        priority: 0,
        API: 2,
        version: "1.0.0",
        overwriteProps: ["quaternion"],

        init: function(target, value, tween) {
            this._target = target;
            if (target.quaternion) this._target = target.quaternion;

            this._quaternionStart = this._target.clone();
            this._quaternionEnd = value.clone();

            return true;
        },

        set: function(ratio) {
            this._super.setRatio.call(this, ratio);

            var quat = new THREE.Quaternion();
            THREE.Quaternion.slerp(this._quaternionStart, this._quaternionEnd, quat, ratio);
            this._target.copy(quat);
        }

    });


}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }



/** WEBPACK FOOTER **
 ** ./holiday-map/threejs/TweenMaxThreeJSPlugin.js
 **/